import postMessage from "./PostMessage";

const moduleTracking = function() {
  return {
    track: function(event, data) {
      var targetOrigin = (window._ab && window._ab.targetOrigin) || '*';
      window.parent.postMessage(
        JSON.stringify({
          action: "track",
          data: {
            event: event,
            data: data
          }
        }),
        targetOrigin
      );
    }
  };
};

function trackingInject(iframe, targetOrigin) {
  return new Promise((resolve) => {
    var moduleTrackingStr = moduleTracking.toString();
    postMessage(
      iframe,
      "evalCode",
      "_ab.tracking = (" + moduleTrackingStr + ")()",
      targetOrigin || "*"
    );
    resolve();
  });
}

const sendHeapEvent = function(event, data) {
  console.log(`Sending tracking event ${event} with data ${JSON.stringify(data)}`);
  if (window.heap) {
    window.heap.track(event, data);
  } else {
    // cascade the event to parent until heap is set
    console.log('window.heap undefined. Cascading tracking event')
    moduleTracking().track(event, data);
  }
};

export default {
  trackingInject,
  sendHeapEvent
};
